import { DefaultRequest } from "scripts/api";

Greenmile.RouteDivisionOrders = Greenmile.RouteDivisionOrders || {};
Greenmile.RouteDivisionOrders.Grid = Greenmile.RouteDivisionOrders.Grid || {};
/**
 * @constructor
 */
Greenmile.RouteDivisionOrders.Grid = function () {
  this.entity = "RouteDivisionOrders";
  this.entityToActionGrid = "RouteDivisionOrders";
  this.containerGrid = "#RouteDivisionGrid .gridContainer";
  this.gridActionsSelector = "#RouteDivisionGrid .gridActions";
  this.filtersToDisplay = [
    "stop.stopDocuments.documentNumber",
    "route.organization",
    "number",
  ];
  this.defaultFilters = {
    "stop.stopDocuments.documentNumber": {
      value: "",
    },
    number: {
      value: "",
    },
  };

  this.show = function () {
    const options = {
      entity: this.entity,
      selectorToGridActions: this.gridActionsSelector,
      entityToActionGrid: this.entityToActionGrid,
      gridContainner: this.containerGrid,
      rowHeight: 30,
      sortBy: 'client',
      multiColumnSort: true
    };

    try {
      const checkboxSelector = new Slick.Data.CheckboxSelectColumn({
        cssClass: "slick-cell-checkboxsel"
      });

      const filterBuilder = new Monet.UI.FilterBuilder();
      const customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
      const saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();
      const routeDivisionCheckBox = new Monet.Grid.ActionsModules.RouteDivisionCheckBox();
      const router = new App.Routers.RouteDivisionOrders();

      router.getFieldsToGridLayout(
        function () {
          const executeFilter = () => {
            Monet.Grid.Utils.clearPagination(this.entity);

            const addDataToGrid = App.Forms.RouteDivisionOrders.table.getData()
              .data.length
              ? Monet.Grid.appendDataToGrid
              : Monet.Grid.addDataToGrid;

            router.updateGrid(addDataToGrid, true);
          };

          const afterInitCallback = () => {
            const routeDivisionModal = document.querySelector('#routeDivisionModalWrapper .routeDivisionModal');
            const modalOffsetLeft = routeDivisionModal.offsetLeft;
            const customizeColumnPopover = routeDivisionModal.querySelector('.MonetUIGridActionsColumns');

            customizeColumnPopover.style.right = `${modalOffsetLeft}px`;
          }

          const afterSaveListCallback = () => {
            App.Forms[this.entity].layout = {};
            const createdFilterBuilder = App.Forms[this.entity].filterBuilder;

            createdFilterBuilder.updateValuesSelectedFilters();
            createdFilterBuilder.saveState();

            this.show();
          };

          filterBuilder.setEntity(this.entityToActionGrid);
          filterBuilder.setSelector(this.containerGrid);
          filterBuilder.setCustomNameSpace(this.entity);
          filterBuilder.setIdScreen("routeDivisionModalWrapper");
          filterBuilder.setFieldsToDisplayOnFilterBuilder(
            this.filtersToDisplay
          );
          filterBuilder.setDefaultFilters(this.defaultFilters);
          filterBuilder.customRequest = executeFilter;
          filterBuilder.selectorContainerFilter = this.gridActionsSelector;
          filterBuilder.render();

          App.Forms.RouteDivisionOrders.filterBuilder = filterBuilder;

          const element = document.querySelector(this.gridActionsSelector);
          const monetUIGridActions = document.createElement("div");

          if (element) {
            element.innerHTML = "";
            element.appendChild(filterBuilder.el);
          }

          monetUIGridActions.setAttribute("class", "MonetUIGridActions");
          element.appendChild(monetUIGridActions);

          customizeColumns.setEntity(this.entityToActionGrid);
          customizeColumns.setScreenName(this.entity);
          customizeColumns.setSelector(this.gridActionsSelector);
          customizeColumns.setElement(monetUIGridActions);
          customizeColumns.setCallBacks({
            afterInit: afterInitCallback,
            afterSaveList: afterSaveListCallback
          });
          customizeColumns.init();

          saveGridLayout.setEntity(this.entityToActionGrid);
          saveGridLayout.setScreenName(this.entity);
          saveGridLayout.setSelector(this.gridActionsSelector);
          saveGridLayout.setElement(monetUIGridActions);
          saveGridLayout.setCallBacks({
            afterSaveList: afterSaveListCallback,
          });
          saveGridLayout.init();

          routeDivisionCheckBox.setEntity(this.entityToActionGrid);
          routeDivisionCheckBox.setScreenName(this.entity);
          routeDivisionCheckBox.setSelector(this.gridActionsSelector);
          routeDivisionCheckBox.setLabel("routeDivisionOrder.label.sameStopCheckbox");
          routeDivisionCheckBox.init();

          element.appendChild(monetUIGridActions);

          filterBuilder.postRender();

          const groupItemMetadataProvider =
            new Slick.Data.GroupItemMetadataProvider({ checkboxSelect: true, checkboxSelectPlugin: checkboxSelector });
          const columns = Monet.Grid.getGridLayout(
            App.Forms.RouteDivisionOrders.layout.index,
            this.entity
          );

          const locationDescriptionColumn = {
            "name": "Location Description",
            "resizable": true,
            "sortable": true,
            "minWidth": 30,
            "rerenderOnResize": false,
            "headerCssClass": null,
            "defaultSortAsc": true,
            "focusable": true,
            "selectable": true,
            "width": 240,
            "field": "stop.location.description",
            "cssClass": "cell-row",
            "fieldInformation": {
                "name": "stop.location.description",
                "label": "Filter.Stop.location.description",
                "type": "TEXT"
            },
            "entity": "RouteDivisionOrders",
            "header": null,
            "widthRequest": 240,
            "autoSize": {
                "ignoreHeaderText": false,
                "autosizeMode": "CTI",
                "rowSelectionMode": "FSN",
                "rowSelectionCount": 100,
                "valueFilterMode": "NONE",
                "widthEvalMode": "CANV"
            }
          }

          columns.unshift(checkboxSelector.getColumnDefinition());
          columns.push(locationDescriptionColumn);

          const dataView = new Monet.Grid.DataProvider(
            columns,
            {
              groupItemMetadataProvider: groupItemMetadataProvider,
            },
            this.entity
          );

          dataView.onRowCountChanged.subscribe(function (e, args) {
            grid.updateRowCount();
          });

          dataView.setGrouping({
            getter: "stop.location.description",
            formatter: function (orders) {
              const totalOrders = orders.count;
              const locationName = orders.value;
              const resourceToOrder =
                totalOrders > 1
                  ? "routeDivisionModal.orders"
                  : "routeDivisionModal.order";
              const locationResource = Monet.I18n.getResourcesByKey(
                "routeDivision.location"
              );
              const locationFullText = `${locationResource}: ${locationName}`;
              const ordersFullText = `${totalOrders} ${Monet.I18n.getResourcesByKey(
                resourceToOrder
              )}`;
              return `${locationFullText} - ${ordersFullText}`;
            },
          });

          const grid = new Monet.Grid.GenericGrid(
            this.containerGrid,
            dataView,
            columns,
            options
          );
          grid.registerPlugin(groupItemMetadataProvider);
          grid.removeScrollToGrid();
          grid.setSelectionModel(new Slick.RowSelectionModel({selectActiveRow: false}));
          grid.registerPlugin(checkboxSelector);
          grid.pagination.scrollEventListenerFunction = () => {};
          grid.groupRows = [];

          dataView.syncGridSelection(grid, true, true);

          App.Forms.RouteDivisionOrders.table = grid;
          App.Forms.RouteDivisionOrders.dataProvider = dataView;
        }.bind(this)
      );
    } catch (e) {
      new Monet.Exception.ReturnError(
        this,
        "Error on show grid on route monitoring.",
        e
      ).console();
    }
  };

  this.parseOrders = function (selectedItems) {
    return selectedItems.map((item) => item.attributes.id);
  };

  this.transferOrders = async function (orderList, routeData) {
    const ordersToTransfer = orderList.map((order) => {
      return {
        id: order,
      };
    });

    const body = {
      route: routeData,
      orders: ordersToTransfer,
    };

    const isMoreThanOneOrder = ordersToTransfer?.length > 1;
    const sucessResource = isMoreThanOneOrder
      ? "Route.TransferOrders.label.successMessage"
      : "Route.TransferOrder.label.successMessage";

    const request = new DefaultRequest({
      url: `/Route/OrdersTransference`,
      method: "POST",
      data: body,
      success: function () {
        App.Forms.RouteDivisionOrders.dataProvider.setData([]);
        new Greenmile.Components.AlertModal(sucessResource)
          .show();
      },
      error: function (err) {
        const { key, value } = JSON.parse(err?.response).errorMessages[0].resource;
        const generalFormError = 'general.form.unknownError'

        if (err) {
          new Greenmile.Components.AlertModal(key ? key : generalFormError).show();
        }

        const error = new Monet.Exception.ReturnError(
          this,
          `Orders was not transfered to Route: ${value || err}`
        );
        error.console();
      },
    });

    await request.send();
  };

  this.transferDataToNewRoute = async function () {
      const routeDivisionOrdersGrid = App.Forms.RouteDivisionOrders.table;
      const selectedItems = routeDivisionOrdersGrid
        .getItemsSelected()
        .filter((item) => item);
      const selectedItemLength = selectedItems?.length;

      const routeDivisionModal =
        GreenmileReduxStore.getState().routeDivisionModal;
      const routeData = routeDivisionModal.get("routeData");
      const orderList = [];

      if (!selectedItemLength) return;

      const selectedOrders = this.parseOrders(selectedItems);

      orderList.push(...selectedOrders);

      if (orderList.length) {
        await this.transferOrders(orderList, routeData);
      }
  };

  this.init = function () {
    this.show();
    return this;
  };
};
